export const GET_ALL_TASKS = 'GET_ALL_TASKS';
export const NEXT_TASK = 'NEXT_TASK';
export const CURRENT_TASK_NUM = 'CURRENT_TASK_NUM';
export const INNER_LOADING = 'INNER_LOADING';
export const GET_ALL_QUESTIONS = 'GET_ALL_QUESTIONS';
export const NEXT_QUESTION = 'NEXT_QUESTION';
export const CURRENT_QUESTION_NUM = 'CURRENT_QUESTION_NUM';
export const SET_PARENT_LOADING = 'SET_PARENT_LOADING';
export const SET_CHILD_LOADING = 'SET_CHILD_LOADING';
export const SET_PRIV_LOADING = 'SET_PRIV_LOADING';
export const GET_USER = 'GET_USER';
export const TASK_SOLUTIONS = 'TASK_SOLUTIONS';
export const ADD_TASKS = 'ADD_TASKS';
export const SET_SCORE = 'SET_SCORE';
export const SET_CURRENT_SCORE = 'SET_CURRENT_SCORE';
export const UPDATE_DB = 'UPDATE_DB';
export const COMPILE_UPVOTES = 'COMPILE_UPVOTES';
export const UPDATE_UPVOTES = 'UPDATE_UPVOTES';
export const GET_USERS = 'GET_USERS';
export const GET_BENCHMARK_RESULT = 'GET_BENCHMARK_RESULT';
export const SET_NEW_TASK_LOADING = 'SET_NEW_TASK_LOADING';
// errors and error handlers
export const SET_STATIC_ERROR = 'SET_STATIC_ERROR';
export const SET_ERROR = 'SET_ERROR';
export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';
export const SET_CHALLENGE_INNER_ERROR = 'SET_CHALLENGE_INNER_ERROR';
// success and success handlers
export const SET_MSG = 'SET_MSG';
export const LOGIN = 'LOGIN';
export const NEW_DESTINATION = 'NEW_DESTINATION';
export const SET_SUCCESS_INDICATOR = 'SET_SUCCESS_INDICATOR';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const INCREMENT_DAILY_UPVOTE = 'INCREMENT_DAILY_UPVOTE';
export const GET_CURRENT_TASK_ID = 'GET_CURRENT_TASK_ID';
export const DISPLAY_SAMPLE = 'DISPLAY_SAMPLE';
